<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex md6 xs6>
                          <v-text-field
                            v-model="filter.division"
                            :label="label.division"
                            :error-messages="errors.collect('division')"
                            data-vv-name="division"
                            :data-vv-as="label.division"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md6 xs6>
                          <v-autocomplete
                            :items="sectorList"
                            v-model="filter.sector"
                            :label="label.sector"
                            item-text="label"
                            item-value="value"
                            data-vv-name="sector"
                            :data-vv-as="label.sector"
                            :error-messages="errors.collect('sector')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNew"> New Division<v-icon right>mdi-plus</v-icon> </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.division }}</td>
                  <td class="text-xs-left">{{ row.item.sector }}</td>
                  <td class="text-xs-left">{{ row.item.divisionDesc }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      review
                      @review="doReview(row.item)"
                      query
                      @query="doQuery(row.item)"
                      remove
                      @remove="doPromptRemove(row.item)"
                    ></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the Division?</p>
        <div class="queryValue">
          Division: {{ selected.division }}<br />
          Sector: {{ selected.sector }}<br />
          Division Description: {{ selected.divisionDesc }}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      toogleArray: [false],
      sectorList: [],
      label: {
        division: 'Division',
        sector: 'Sector',
        divisionDesc: 'Division Description'
      },
      filter: {
        division: null,
        sector: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Division', align: 'left', value: 'division' },
        { text: 'Sector', align: 'left', value: 'sector' },
        { text: 'Division Description', align: 'left', value: 'divisionDesc' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selected: {
        division: null,
        sector: null,
        divisionDesc: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    await this.$store.dispatch('divisionInit')
    this.fetchData(true)
    this.doInit()
  },
  methods: {
    async doInit() {
      this.fetchData(true)
      this.fetchSectorList()
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getDivisionList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  division: datamap.division,
                  sector: datamap.sector,
                  divisionDesc: datamap.divisionDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async fetchSectorList() {
      const apiUrl = this.menu.sectorList
      if (apiUrl) {
        try {
          this.sectorList = []
          const result = await this.$http.get(apiUrl)
          if (result.data.dataList) {
            this.$set(this, 'sectorList', result.data.dataList)
          }
        } catch (err) {
          this.sectorList = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.division = null
      this.filter.sector = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteDivision
          const expand = {
            division: data.division,
            sector: data.sector
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selected.division = data.division
          this.selected.sector = data.sector
          this.selected.divisionDesc = data.divisionDesc
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.division) {
        const apiURI = this.menu.deleteDivision
        if (apiURI) {
          const expand = {
            division: this.selected.division,
            sector: this.selected.sector,
            divisionDesc: this.selected.divisionDesc
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        division: null,
        sector: null,
        divisionDesc: null
      }
      sessionStorage.setItem('division', JSON.stringify(commit))
      this.$store.commit('DIVISION_COMMIT_KEY', commit)
      this.$router.push({ name: 'divisionReview' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        division: data.division,
        sector: data.sector,
        divisionDesc: data.divisionDesc
      }
      sessionStorage.setItem('division', JSON.stringify(commit))
      this.$store.commit('DIVISION_COMMIT_KEY', commit)
      this.$router.push({ name: 'divisionReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        division: data.division,
        sector: data.sector,
        divisionDesc: data.divisionDesc
      }
      sessionStorage.setItem('division', JSON.stringify(commit))
      this.$store.commit('DIVISION_COMMIT_KEY', commit)
      this.$router.push({ name: 'divisionReview' })
    }
  },
  computed: {
    menu() {
      return this.$store.state.boIncenSchParam.division.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
